import { ResizeObserver } from '@juggle/resize-observer'
import defaultResizeObserver from 'use-resize-observer'

declare global {
  interface Window {
    ResizeObserver?: typeof ResizeObserver
  }
}

export interface ObservedSize {
  width: number | undefined
  height: number | undefined
}
export type ResizeHandler = (size: ObservedSize) => void

/* istanbul ignore next */
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver
}

export const useResizeObserver = defaultResizeObserver
